import { Injectable } from '@angular/core';
import Debug from 'debug';
import { Subject } from 'rxjs';

const debug = Debug('aumico:aumico-lib-core-fe:ActionHeaderService');

@Injectable({
    providedIn: 'root',
})
export class ActionHeaderService {
    private onActionEvent = new Subject<IAumGlobalActionEvent>();
    onActionEvent$ = this.onActionEvent.asObservable();

    onAction(action: IAumGlobalActionEvent) {
        debug(action);
        this.onActionEvent.next(action);
    }
}

export enum AumGlobalAction {
    GOBACK = 'GOBACK',
    FILTER = 'FILTER',
    NEW = 'NEW',
    SEARCH = 'SEARCH',
    UNDO = 'UNDO',
    REDO = 'REDO',
    PROCEED = 'PROCEED',
    SAVE = 'SAVE',
    SAVEndPROCEED = 'SAVE&PROCEED',
    ACTIONHEADERUPDATE = 'ACTIONHEADERUPDATE',
    UPDATECURRENTENTITY = 'UPDATECURRENTENTITY',
}

export interface IAumGlobalActionEvent {
    action: AumGlobalAction;
    value: any;
}
